__turbopack_context__.v({
  "alignLeft": "gnKjra_alignLeft",
  "alignRight": "gnKjra_alignRight",
  "bulletIcon": "gnKjra_bulletIcon",
  "ctaContainer": "gnKjra_ctaContainer",
  "ctaContent": "gnKjra_ctaContent",
  "fadeIn": "gnKjra_fadeIn",
  "iconContainer": "gnKjra_iconContainer",
  "iframeContainer": "gnKjra_iframeContainer",
  "imgContainer": "gnKjra_imgContainer",
  "overlay": "gnKjra_overlay",
  "root": "gnKjra_root",
  "subtitle": "gnKjra_subtitle",
  "subtitleLight": "gnKjra_subtitleLight",
  "tag": "gnKjra_tag",
  "title": "gnKjra_title",
  "titleLight": "gnKjra_titleLight",
});
